import svgUrl from '@images/map-pin.svg'
import { Box } from '@mui/material'
import { CSSProperties } from 'react'

interface iconProps {
    sx?: CSSProperties
}

const MapPinIcon = (props: iconProps) => {
    return (
        <Box style={{ height: 20, width: 20, ...props.sx }}>
            <img src={svgUrl} alt="map-pin-icon" style={{ height: 'inherit', width: 'inherit' }} />
        </Box>
    )
}

export default MapPinIcon
